@if (parameters) {
  <p-tabs scrollable value="{{ selected_module }}">
    <p-tablist>
      @if (
        selected_module === 'wgmenu' ||
        selected_module === 'chatlist' ||
        selected_module === 'notemodule' ||
        selected_module === 'taskmodule' ||
        selected_module === 'contactsmodule' ||
        selected_module === 'emailmodule' ||
        (selected_module !== 'chatlist' &&
          selected_module !== 'chatroom' &&
          selected_module !== 'chatwrite')
      ) {
        <p-tab value="chatlist" (click)="selectedModule('chatlist')">
          {{ 'Chats' | translate }}
        </p-tab>
      }
      @if (selected_module === 'chatroom') {
        <p-tab value="chatroom" (click)="selectedModule('chatlist')">
          {{ 'Chat' | translate }}
        </p-tab>
      }

      @if (selected_module === 'chatwrite') {
        <p-tab value="chatwrite" (click)="selectedModule('chatlist')">
          {{ 'Chat' | translate }}
        </p-tab>
      }

      @if (workgroup_menu) {
        <p-tab value="wgmenu" (click)="selectedModule('wgmenu')">
          {{ 'Workgroup / Project' | translate }}</p-tab
        >
      }
      @if (used_module !== 'notes') {
        <p-tab value="notemodule" (click)="selectedModule('notemodule')">
          {{ 'Notes' | translate }}</p-tab
        >
      }

      @if (used_module !== 'tasks') {
        <p-tab value="taskmodule" (click)="selectedModule('taskmodule')">
          {{ 'Tasks' | translate }}</p-tab
        >
      }

      @if (used_module !== 'contacts') {
        <p-tab value="contactsmodule" (click)="selectedModule('contactsmodule')">
          {{ 'Contacts' | translate }}</p-tab
        >
      }

      @if (used_module !== 'emails') {
        <p-tab value="emailmodule" (click)="selectedModule('emailmodule')">
          {{ 'Emails' | translate }}</p-tab
        >
      }

      <p-tab value="calendarmodule" (click)="selectedModule('calendarmodule')">
        {{ 'Calendar' | translate }}</p-tab
      >
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel value="chatlist">
        <div class="block">
          @if (selectedBusiness()) {
            <section class="communication communication--medium">
              <div class="communication__content">
                <offconon-chat-channel-list
                  [platform]="'erp'"
                  [parameters]="parameters"
                  [selectedBusiness]="selectedBusiness()"
                  [chatSettings]="selectedBusiness()?.chat_settings"
                  (selectedModule)="selectedModule($event)"
                  (selectedChatRoomId)="selectedChatRoomId($event)" />
              </div>
            </section>
          }
        </div>
      </p-tabpanel>

      <p-tabpanel value="chatroom">
        @defer (when selected_module === 'chatroom') {
          <div class="block" [class.hidden]="selected_module !== 'chatroom'">
            <offconon-chat-in-chat-selected
              [parameters]="parameters"
              [platform]="'erp'"
              [selectedBusiness]="selectedBusiness()" />
          </div>
        }
      </p-tabpanel>

      <p-tabpanel value="chatwrite">
        @defer (when selected_module === 'chatwrite') {
          <div class="block" [class.hidden]="selected_module !== 'chatwrite'">
            <offconon-chat-new-message-erp [parameters]="parameters" />
          </div>
        }
      </p-tabpanel>

      <p-tabpanel value="notemodule">
        @defer (when selected_module === 'notemodule') {
          <div class="block" [class.hidden]="selected_module !== 'notemodule'">
            @if (parameters) {
              <offconon-notes-right-panel-render [parameters]="parameters" />
            }
          </div>
        }
      </p-tabpanel>

      <p-tabpanel value="calendarmodule">
        @defer (when selected_module === 'calendarmodule') {
          <div class="block" [class.hidden]="selected_module !== 'calendarmodule'">
            @if (parameters) {
              calendarmodule
            }
          </div>
        }
      </p-tabpanel>

      <p-tabpanel value="taskmodule">
        @defer (when selected_module === 'taskmodule') {
          <div class="block" [class.hidden]="selected_module !== 'taskmodule'">
            @if (parameters) {
              <offconon-tasks-right-panel-render [parameters]="parameters" />
            }
          </div>
        }
      </p-tabpanel>
      <p-tabpanel value="contactsmodule">
        @defer (when selected_module === 'contactsmodule') {
          <div class="block" [class.hidden]="selected_module !== 'contactsmodule'">
            @if (parameters) {
              <offconon-contacts-right-panel-render [parameters]="parameters" />
            }
          </div>
        }
      </p-tabpanel>
      <p-tabpanel value="emailmodule">
        @defer (when selected_module === 'emailmodule') {
          <div class="block" [class.hidden]="selected_module !== 'emailmodule'">
            @if (parameters) {
              <offconon-email-accounts-content-right-panel-render [parameters]="parameters" />
            }
          </div>
        }
      </p-tabpanel>
      @if (workgroup_menu) {
        <p-tabpanel value="wgmenu">
          @defer (when selected_module === 'wgmenu') {
            <div class="block" [class.hidden]="selected_module !== 'wgmenu'">
              <offconon-shared-task-workgroup-panel />
            </div>
          }
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
}
